"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var FaceFemaleSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M8.5,2 C12.0118106,2 15,4.85090614 15,8.5 C15,10.2372004 15,12.0705338 15,14 L12.2418796,14.0005166 C11.4345715,15.2062125 10.0599853,16 8.5,16 C6.94011331,16 5.5656022,15.2063128 4.75827342,14.0007452 L2,14 L2,8.5 C2,4.91014913 4.91014913,2 8.5,2 Z M7.60492116,6.99299748 C7.07578783,7.98025888 6.077959,8.76405965 5.00058185,8.95525262 L5,11.5 C5,13.4329966 6.56700338,15 8.5,15 C10.3685634,15 12.0005301,13.4685653 12,11.5 C12.0003534,10.8145444 12.0005301,9.97519838 12.0005301,8.98196184 C10.210884,8.85361414 8.48534556,8.05315818 7.60492116,6.99299748 Z M14,9 L13,9 L13,11.5 C13,12.0263612 12.9096286,12.531615 12.7435553,13.0010919 L14,13 L14,9 Z M4,9 L3,9 L3,13 L4.2562757,13.0006142 C4.11270706,12.5946097 4,12.1275885 4,11.5 C4,10.9845953 4,10.1512619 4,9 Z M8.5,3 C5.63099074,3 3.27505563,5.1967316 3.02242468,7.99996478 L4.64702886,7.99395954 C5.77487059,7.9019909 7.0513916,6.65731812 7,5.507 C7.07391357,4.82347107 7.94839478,4.88424683 7.99194433,5.41012437 C7.96842957,6.63902283 10.0980129,7.91347803 12.2814464,7.99585541 L13.9776139,8.00039328 C13.7251845,5.19695546 11.3691554,3 8.5,3 Z" })));
};
FaceFemaleSmall.displayName = 'FaceFemaleSmall';
exports.default = FaceFemaleSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=FaceFemaleSmall.js.map